let _ = t => t,
  _t;
import styled from 'styled-components';
export const Badge = styled.div(_t || (_t = _`
    display: inline-flex;
    gap: 8px;
    align-items: center;
    justify-content: center;

    padding: 2px 8px;

    border-radius: 4px;
`));